import { User, signOut } from "firebase/auth";
import { ReactNode, createContext, useContext, useEffect, useState } from "react";
import { firebaseAuth } from "../services/firebaseAuth";
import { toastStore } from "../utils/toastStore";

type Context = { user: User | null; logout: () => Promise<void> };

const AuthContext = createContext<Context | undefined>(undefined);

const AuthProvider = ({ children }: { children: ReactNode }) => {
  //
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const unsubscribe = firebaseAuth.onAuthStateChanged((value) => {
      console.log(value);
      setUser(value);
    });
    return unsubscribe;
  }, []);

  const logout = () => {
    return signOut(firebaseAuth)
      .then(() => {
        toastStore.info(`Successfully signed out`);
      })
      .catch((error) => {
        toastStore.error(`Error in signing out the user. ${error.message}`);
      });
  };

  return <AuthContext.Provider value={{ user, logout }}>{children}</AuthContext.Provider>;
};

function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useFirebaseAuth must be used within a FirebaseAuthProvider");
  }
  return context;
}

export { AuthProvider, useAuth };
